import { NgModule, Optional, SkipSelf } from '@angular/core';

// application modules
import { SharedModule } from '../shared/shared.module';
// components/directives/pipes
import { BillAccountTermsComponent } from './bill-account-terms';
import { GoPaperlessTermsComponent } from './go-paperless-terms';
import { KnowYourDriveSmartphoneTermsComponent } from './know-your-drive-smartphone-terms/know-your-drive-smartphone-terms.component';
import { KnowYourDriveTermsComponent } from './know-your-drive-terms';

@NgModule({
  imports: [SharedModule],
  declarations: [
    BillAccountTermsComponent,
    GoPaperlessTermsComponent,
    KnowYourDriveTermsComponent,
    KnowYourDriveSmartphoneTermsComponent
  ],
  exports: [
    BillAccountTermsComponent,
    GoPaperlessTermsComponent,
    KnowYourDriveTermsComponent,
    KnowYourDriveSmartphoneTermsComponent
  ]
})
export class TermsModule {
  constructor(@Optional() @SkipSelf() parentModule: TermsModule) {
    if (parentModule) {
      throw new Error('TermsModule is already loaded. Lazy load only');
    }
  }
}
